import Provider from "./TicketStatusContext"
import TicketStatus from "./TicketStatus"

let Index = () => {
    return (
        <Provider>
            <TicketStatus />
        </Provider>
    )
}

export default Index